export default "__VITE_ASSET__BLRLd_U1__"